import type { CartAddressData } from 'services';
import type { AddressFormData } from '../../../types';
import { getPostnummer } from './getPostnummer';
import { getStationNumber } from './getStationNumber';
import { getStreetAddOn } from './getStreetAddOn';

interface CreateAddressFormDataOptions {
  address?: CartAddressData;
  company: boolean;
  pickupPoint: boolean;
  initialCountry: string;
}

/** Maps a saved address to the normalized controlled address-form shape. */
export function createAddressFormData({
  address,
  company,
  pickupPoint,
  initialCountry
}: CreateAddressFormDataOptions): AddressFormData {
  if (!address) {
    return {
      company: '',
      firstName: '',
      lastName: '',
      street: '',
      streetAddOn: '',
      salesTaxId: '',
      postnummer: '',
      stationNumber: '',
      zip: '',
      city: '',
      country: initialCountry,
      phone: ''
    };
  }

  return {
    company: address.company ?? '',
    firstName: address.firstName ?? '',
    lastName: address.lastName ?? '',
    street: [address.street, address.houseNumber].filter(Boolean).join(' '),
    streetAddOn: getStreetAddOn(address, company, pickupPoint),
    salesTaxId: address.salesTaxId ?? '',
    postnummer: getPostnummer(address, pickupPoint),
    stationNumber: getStationNumber(address, pickupPoint),
    zip: address.zip ?? '',
    city: address.city ?? '',
    country: initialCountry,
    phone: address.phone ?? ''
  };
}